var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95591 0.706055H5.04956V2.30674H5.95591V0.706055Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.86796 2.15937L8.33911 3.06445L8.97302 3.4255L9.50188 2.52042L8.86796 2.15937Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.26306 2.07506L1.62915 2.43604L2.1579 3.34112L2.79181 2.98014L2.26306 2.07506Z",
    fill: "#F2F2F2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.56975C11 10.571 8.53992 12.9998 5.5 12.9998C2.46008 12.9998 0 10.571 0 7.56975C0 4.56846 2.46008 2.13965 5.5 2.13965C8.53992 2.13965 11 4.56846 11 7.56975Z",
    fill: "#612A71"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7.56975C11 4.56846 8.53992 2.13965 5.5 2.13965V12.9998C8.53992 12.9998 11 10.571 11 7.56975Z",
    fill: "#612A71"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0936 7.56994C10.0936 10.071 8.0388 12.1052 5.4999 12.1052C2.96101 12.1052 0.90625 10.0766 0.90625 7.56994C0.90625 5.06331 2.96101 3.03467 5.4999 3.03467C8.0388 3.03467 10.0936 5.06887 10.0936 7.56994Z",
    fill: "#F5F5F5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0937 7.56994C10.0937 5.06331 8.03889 3.03467 5.5 3.03467V12.0997C8.03889 12.1052 10.0937 10.0766 10.0937 7.56994Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49993 8.68692C4.87506 8.68692 4.36841 8.18671 4.36841 7.56978C4.36841 6.95285 4.87506 6.45264 5.49993 6.45264C6.12481 6.45264 6.63146 6.95285 6.63146 7.56978C6.63146 8.18671 6.12481 8.68692 5.49993 8.68692ZM5.49993 6.64161C4.98202 6.64161 4.55981 7.05845 4.55981 7.56978C4.55981 8.08111 4.98202 8.49795 5.49993 8.49795C6.01785 8.49795 6.44006 8.08111 6.44006 7.56978C6.44006 7.05845 6.01785 6.64161 5.49993 6.64161Z",
    fill: "#C8C8C8"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69128 7.70889L5.35352 7.38097L8.53417 4.57422L5.69128 7.70889Z",
    fill: "#612A71"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.85672 0H4.14331V1.15049H6.85672V0Z",
    fill: "#F2F2F2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63463 2.17314L1.53125 2.80119L0.855713 1.64514L1.95909 1.01709L2.63463 2.17314Z",
    fill: "#F2F2F2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M9.17944 1.10461L8.50391 2.25977L9.60569 2.88781L10.2812 1.73265L9.17944 1.10461Z",
    fill: "#F2F2F2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M4.43601 9.0817L3.96313 8.62039L5.20725 7.39209L5.68013 7.8534L4.43601 9.0817Z",
    fill: "#612A71"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M5.80397 7.8202C5.64634 7.97582 5.39865 7.97582 5.24102 7.8202C5.0834 7.66457 5.0834 7.42003 5.24102 7.2644C5.39865 7.11434 5.64634 7.11434 5.80397 7.2644C5.9616 7.42003 5.9616 7.67013 5.80397 7.8202Z",
    fill: "#F2F2F2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6914 3.3125H5.30859V3.97945H5.6914V3.3125Z",
    fill: "#C8C8C8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M5.6914 11.1602H5.30859V11.8271H5.6914V11.1602Z",
    fill: "#C8C8C8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M9.81226 7.38086H9.13672V7.7588H9.81226V7.38086Z",
    fill: "#C8C8C8"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86328 7.38086H1.18774V7.7588H1.86328V7.38086Z",
    fill: "#C8C8C8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M1.81423 5.35981L1.71851 5.52344L2.30345 5.85698L2.39917 5.69335L1.81423 5.35981Z",
    fill: "#C8C8C8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M8.69608 9.28413L8.60034 9.44775L9.18529 9.78136L9.28103 9.61773L8.69608 9.28413Z",
    fill: "#C8C8C8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M7.57347 3.83788L7.23584 4.41553L7.40161 4.50997L7.73925 3.93233L7.57347 3.83788Z",
    fill: "#C8C8C8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M3.59897 10.6314L3.26025 11.2085L3.42585 11.3032L3.76457 10.7262L3.59897 10.6314Z",
    fill: "#C8C8C8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42725 3.83864L3.26147 3.93311L3.59918 4.51075L3.76495 4.41629L3.42725 3.83864Z",
    fill: "#C8C8C8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40113 10.6292L7.23535 10.7236L7.57305 11.3013L7.73883 11.2068L7.40113 10.6292Z",
    fill: "#C8C8C8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M9.18372 5.36051L8.59863 5.69385L8.6943 5.85751L9.27938 5.52417L9.18372 5.36051Z",
    fill: "#C8C8C8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M2.30485 9.28393L1.71997 9.61768L1.81575 9.78129L2.40063 9.44754L2.30485 9.28393Z",
    fill: "#C8C8C8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon_clock.241d6255d0c7995e8c0fcd1acde16508.svg";
export { ForwardRef as ReactComponent };